'use strict';

// List all custom fields
function customFields() {
  return {
    restrict: 'AE',
    replace: true,
    scope: {
      fields: '='
    },
    transclude: true,
    template: `<div ng-repeat="field in fields track by $index">
      <custom-select ng-model="field.value" data="field" ng-if="field.options"></custom-select>
      <custom-text ng-model="field.value" data="field" ng-if="!field.options && field.type === 'TEXT'"></custom-text>
      <custom-number ng-model="field.value" data="field" ng-if="field.type === 'NUMBER'"></custom-number>
      <custom-date ng-model="field.value" data="field" ng-if="field.type === 'DATE'"></custom-date>
      <custom-check ng-model="field.value" data="field" ng-if="field.type === 'BOOLEAN'"></custom-check>
    </div>`
  };
}

// TEXT
function customText() {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      field: '=data'
    },
    require: 'ngModel',
    template: `<div>
      <label for="customField_{{ field.number }}">{{ field.name }}</label>
      <input type="text" name="customFields[{{ field.number }}].value" id="customField_{{ field.number }}" />
    </div>`,
    link: (scope, element, attr, ctrl) => {
      scope.$watch('field.value', function (newVal) {
        element.find('input').val(newVal);
      });

      element.find('input').bind('input propertychange paste', () => {
        scope.$apply(function () {
          ctrl.$setViewValue(element.find('input').val());
        });
      });
    }
  };
}

// NUMBER
function customNumber() {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      field: '=data'
    },
    require: 'ngModel',
    template: `<div>
      <label for="customField_{{ field.number }}">{{ field.name }}</label>
      <div class="row collapse">
        <div class="columns" ng-class="{ 'large-8': field.price, 'large-12': !field.price }">
          <input type="number" name="customFields[{{ field.number }}].value" id="customField_{{ field.number }}" />
        </div>
        <div class="large-4 columns" ng-show="field.price">
          <span class="postfix">&times; {{ field.price.price | crowns }}</span>
        </div>
      </div>
    </div>`,
    link: (scope, element, attr, ctrl) => {
      scope.$watch('field.value', function (newVal) {
        element.find('input').val(newVal);
      });

      element.find('input').bind('input propertychange paste', () => {
        scope.$apply(function () {
          ctrl.$setViewValue(parseInt(element.find('input').val(), 10));
        });
      });
    }
  };
}

// DATE
function customDate(commonService) {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      field: '=data'
    },
    require: 'ngModel',
    template: `<div>
      <label for="customField_{{ field.number }}">{{ field.name }}</label>
      <input type="datetime" name="customFields[{{ field.number }}].value" id="customField_{{ field.number }}" placeholder="dd.mm.åååå" formnovalidate />
    </div>`,
    link: (scope, element, attr, ctrl) => {
      scope.$watch('field.value', function (newVal) {
        if (moment(newVal, 'DD.MM.YYYY', true).isValid()) {
          element.find('input').val(newVal);
        }
      });

      commonService.datePicker({
        field: element.find('input')[0],
        format: 'DD.MM.YYYY',
        onSelect: function () {
          scope.$apply(function () {
            ctrl.$setViewValue(element.find('input').val());
          });
        }
      });

      element.find('input').bind('input propertychange paste', () => {
        scope.$apply(function () {
          ctrl.$setViewValue(element.find('input').val());
        });
      });
    }
  };
}

// SELECT
function customSelect() {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      field: '=data'
    },
    require: 'ngModel',
    template: `<div>
      <label for="customField_{{ field.number }}">{{ field.name }}</label>
      <select name="customFields[{{ field.number }}].value" id="customField_{{ field.number }}" ng-model="field.value" ng-if="!field.options[0].price">
        <option value="">---</option>
        <option ng-if="!option.value" ng-repeat="option in field.options" ng-value="option">{{ option }}</option>
        <option ng-if="option.value" ng-repeat="option in field.options" ng-value="option.value">{{ option.value }}</option>
      </select>
      <select ng-show="field.options" name="customFields[{{ $index + 1 }}].value" id="customField_{{ field.number }}" ng-options="option.value as option.value + ' - ' + (option.price.price | crowns) for option in field.options" ng-model="field.value" ng-required="field.required" ng-if="field.options[0].price">
        <option value="">---</option>
      </select>
    </div>`,
    link: (scope, element, attr, ctrl) => {
      element.find('select').bind('change', () => {
        scope.$apply(function () {
          ctrl.$setViewValue(element.find('select').val());
        });
      });
    }
  };
}

// CHECKBOX
function customCheck() {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      field: '=data'
    },
    require: 'ngModel',
    template: `<div>
      <label for="customField_{{ field.number }}" class="inline">
        <input type="checkbox" name="customFields[{{ field.number }}].value" id="customField_{{ field.number }}" ng-checked="field.value" />
        {{ field.name }}
        <span ng-show="field.price"> - {{ field.price.price | crowns }}</span>
      </label>
    </div>`,
    link: (scope, element, attr, ctrl) => {
      element.find('label').bind('click', () => {
        scope.$apply(function () {
          ctrl.ngModel = !ctrl.ngModel;
          element.find('input').val(ctrl.ngModel).prop('checked', ctrl.ngModel);
          ctrl.$setViewValue(ctrl.ngModel);
        });
      });
    }
  };
}

customDate.$inject = ['commonService'];

angular
  .module('SendRegning')
  .directive('customFields', customFields)
  .directive('customText', customText)
  .directive('customNumber', customNumber)
  .directive('customDate', customDate)
  .directive('customSelect', customSelect)
  .directive('customCheck', customCheck);
